export default {
  namespaced: true,
  state: {
    informationToastText: '',
    isShowInformationToast: true,
    isShowInformationBullet: true
  },
  mutations: {
    setInformationToastText(state, informationToastText) {
      state.informationToastText = informationToastText
    },
    setIsShowInformationToast(state, isShowInformationToast) {
      state.isShowInformationToast = isShowInformationToast
    },
    setIsInformationBullet(state, isShowInformationBullet) {
      state.isShowInformationBullet = isShowInformationBullet
    }
  },
  actions: {
    checkInformationToast({ commit, rootState, rootGetters }) {
      if (
        rootState.auth.isLogged === true &&
        rootState.account.canShowInformationToast === true &&
        rootState.account.subscription.paymentGateway !== 'ios'
      ) {
        if (rootState.account.subscription.isRecurrent === false && rootGetters['user/isInfinity'].length === 0) {
          if (rootState.account.subscriptionCycleDaysLeft <= 45) {
            commit(
              'setInformationToastText',
              `Sua assinatura expira em ${rootState.account.subscriptionCycleDaysLeft} dias. Reative agora e garanta suas vantagens!`
            )
            commit('setIsShowInformationToast', true)
          } 
          else if (rootState.user.userLastPaymentMethod.methodType === 'credit_card') {
            if (rootState.user.isCreditCardExpired === true) {
              commit('setInformationToastText', 'Você possui um aviso em Conta')
              commit('setIsShowInformationToast', true)
            } else {
              commit('setIsShowInformationToast', false)
            }
          } 
          else {
            commit('setIsShowInformationToast', false)
          }
        } else {
          if (rootState.user.userLastPaymentMethod.methodType === 'credit_card') {
            if (rootState.user.isCreditCardExpired === true) {
              commit('setInformationToastText', 'Você possui um aviso em Conta')
              commit('setIsShowInformationToast', true)
            } else {
              commit('setIsShowInformationToast', false)
            }
          } else {
            commit('setIsShowInformationToast', false)
          }
        }
      } else {
        commit('setIsShowInformationToast', false)
      }
    },
    checkInformationBullet({ commit, rootState, rootGetters }) {
      if (
        ((rootState.account.subscription.isRecurrent === false && rootState.account.subscriptionCycleDaysLeft <= 45) ||
        (rootState.user.userLastPaymentMethod.methodType === 'credit_card' && rootState.user.isCreditCardExpired === true))
      ) {
        if (rootState.account.subscription.paymentGateway !== 'ios' && rootGetters['user/isInfinity'].length === 0) {
          commit('setIsInformationBullet', true)
        } else {
          commit('setIsInformationBullet', false)
        }
      } else {
        commit('setIsInformationBullet', false)
      }
    }
  },
  getters: {
    informationToastText: state => state.informationToastText,
    isShowInformationToast: state => state.isShowInformationToast,
    isShowInformationBullet: state => state.isShowInformationBullet
  }
}
